<template>
  <div class="position-relative" style="isolation: isolate">
    <button class="w-100 btn text-center position-relative rounded-0 py-3 overflow-hidden"
      :class="{ 'active': isActive, [color]: true }" style="line-height: 1em" @click="emits('click')">
      <AVIcon :icon="icon" class="h5 mb-0" /><br>
      <span v-if="unreadCount" class="badge rounded-pill bg-theme-danger position-absolute" style="top: 15%; left: 60%">
        {{ unreadCount }}
      </span>
      <span class="circle pulse-button" v-if="pulse"></span>
      <span class="small visually-hidden">{{ text }}</span>
    </button>
    <div class="hover-label my-auto position-absolute m-auto d-grid align-items-center px-2">
      <small class="text-light bg-blur-darker border border-dark rounded text-nowrap p-2">
        {{ text }}
      </small>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  icon: {
    type: String,
    default: "",
  },
  unread: {
    type: Number,
    default: 0,
  },
  text: {
    type: String,
    default: "",
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: "btn-theme",
  },
  pulse: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["click"]);

const unreadCount = computed(() => {
  let count = null;
  count = props.unread > 0 ? props.unread : null;
  if (props.unread > 999) count = 999;
  return count;
});
</script>

<style scoped lang="scss">
:hover>.hover-label,
:focus-within> :not(.active)+.hover-label {
  right: 100%;
  opacity: 1.0;
}

.hover-label {
  right: -100%;
  opacity: 0.0;
  transition: all 0.1s ease;
  top: 0;
  bottom: 0;
  z-index: -1;
}

html[dir=rtl] {

  :hover>.hover-label,
  :focus-within> :not(.active)+.hover-label {
    right: auto;
    left: 100%;
  }

  .hover-label {
    right: auto;
    left: -100%;
  }
}
</style>
